import { create } from 'zustand';
import type { QueuedDialog } from '../types/ui/queuedDialog';

interface DialogQueueStore {
  queue: QueuedDialog[];
  currentDialog: QueuedDialog | null;

  // Actions
  showDialog: (dialog: QueuedDialog) => void;
  hideDialog: () => void;
  clearQueue: () => void;
}

export const useDialogQueueStore = create<DialogQueueStore>((set) => ({
  queue: [],
  currentDialog: null,

  showDialog: (dialog: QueuedDialog) => {
    set((state) => {
      const newQueue = [...state.queue, dialog];

      // If no dialog is currently shown, show this one immediately
      if (!state.currentDialog) {
        return {
          queue: newQueue.slice(1), // Remove from queue since it's now current
          currentDialog: dialog
        };
      }

      // Otherwise add to queue
      return {
        queue: newQueue,
        currentDialog: state.currentDialog
      };
    });
  },

  hideDialog: () => {
    set((state) => {
      const nextDialog = state.queue[0];
      return {
        currentDialog: nextDialog || null,
        queue: nextDialog ? state.queue.slice(1) : state.queue
      };
    });
  },

  clearQueue: () => {
    set(() => ({
      queue: [],
      currentDialog: null
    }));
  }
}));
